import { call, put } from "redux-saga/effects"

import api from "apis"
import { setLocalStorage } from "helpers/application"

import { setMessage, setUserData } from "../actions"

export default function* sendUserInfo(action) {
  yield put(setMessage("provideUserInfo", "", ""))
  const values = action.values
  let url = "/api/v10/user/update_info"
  const result = yield call(api.authPost, url, values)

  if (result?.data) {
    yield put(setUserData(result.data.jewlrorders.user))

    setLocalStorage(result.data.jewlrorders.user, "user_obj")

    yield put(
      setMessage("provideUserInfo", "success", "Your changes have been saved!")
    )
    action.setSubmitting(false)
    action.setShowEditModal(false)
  } else {
    action.setStatus({
      errors: result.error,
    })
    action.setSubmitting(false)
    // TODO: Need a success modal for registering rest of user info
    // yield put(openModal('register-success'))
  }
}
